var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('nav',{staticClass:"text-right mt-2",staticStyle:{"text-align":"right"}},[_c('span',{staticClass:"btn-link text-secondary",staticStyle:{"cursor":"pointer","padding-right":"2em"},on:{"click":function($event){return _vm._loginLogout()}}},[_vm._v(_vm._s(_vm.ls))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }